package com.islamicmedia.site.components

import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import kotlin.js.json

private const val LOTTIE_URL = "https://assets-v2.lottiefiles.com/a/144a2954-5dfd-11ef-8711-174680cf6010/lm058RGFQq.json"
private const val LOTTIE_CDN = "https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js"

@Composable
fun SearchingAnimation(size: Int = 120) {
    val containerId = remember { "lottie-${kotlin.random.Random.nextInt(100000)}" }

    Div(attrs = {
        id(containerId)
        style {
            width(size.px)
            height(size.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
        }
    })

    LaunchedEffect(containerId) {
        initLottie(containerId)
    }
}

private fun initLottie(containerId: String) {
    val lottie = window.asDynamic().lottie
    if (lottie != null && lottie != undefined) {
        loadAnimation(containerId)
    } else {
        // Load lottie library first
        val script = document.createElement("script")
        script.asDynamic().src = LOTTIE_CDN
        script.asDynamic().onload = {
            loadAnimation(containerId)
        }
        document.head?.appendChild(script)
    }
}

private fun loadAnimation(containerId: String) {
    val container = document.getElementById(containerId)
    if (container != null) {
        container.innerHTML = ""
        val lottie = window.asDynamic().lottie
        if (lottie != null && lottie != undefined) {
            lottie.loadAnimation(
                json(
                    "container" to container,
                    "renderer" to "svg",
                    "loop" to true,
                    "autoplay" to true,
                    "path" to LOTTIE_URL
                )
            )
        }
    }
}
